var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFix({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 76 75",
    style: {
      enableBackground: "new 0 0 76 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4,8.8c-1,2-1.5,4.3-1.5,6.6c0,4.1,1.6,8,4.5,10.9c2.9,2.9,6.8,4.5,11,4.5 c2.3,0,4.6-0.5,6.6-1.5c-2.8,2.8-6.5,4.3-10.4,4.3c-1,0-2-0.1-3-0.3c-1.6-0.3-3.3,0.2-4.5,1.3L21,62.6c-0.1-4.4-3.7-7.9-8.1-8.1 l28.2-28c1.2-1.2,1.7-2.8,1.3-4.4C41.4,17.3,42.9,12.3,46.4,8.8L46.4,8.8L46.4,8.8z M51.3,51.1l15.5,15.4c0.9,0.9,0.9,2.3,0,3.1 c-0.8,0.8-2.3,0.8-3.1,0L48.2,54.2L51.3,51.1L51.3,51.1z M54.8,0c-0.4,0-0.7,0-1.1,0.1c-11,1.7-18.3,12.2-16,23L5,55.4 c-4.2,4.1-4.2,10.8,0,14.9c4.1,4.1,10.9,4.1,15,0L52.7,38c11,2.3,21.5-5,23.2-15.9c0.4-2.6-0.6-4.1-2-4.1c-0.6,0-1.4,0.3-2,1 l-3.9,3.8c-4.1,4.1-10.9,4.1-15,0c-4.2-4.1-4.2-10.8,0-14.9l3.9-3.8C58.7,2.2,57.8,0,54.8,0L54.8,0z M10.1,65.4 c-2.2-2.2-0.6-6,2.5-6s4.8,3.8,2.5,6C13.7,66.7,11.4,66.7,10.1,65.4z M5,3.3l-5,5l6.3,8.7l5.2,2.7l12.3,12.2l5-5L16.5,14.7l-2.8-5.2 L5,3.3z M50.1,45.5l-7.5,7.4c-0.7,0.7-0.7,1.8,0,2.5L60.3,73c2.8,2.7,7.3,2.7,10,0s2.8-7.2,0-9.9L52.6,45.5 C51.9,44.8,50.8,44.8,50.1,45.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFix);
export default __webpack_public_path__ + "static/media/fix.fefa94a2c09d6dbcc5db72a3364c980d.svg";
export { ForwardRef as ReactComponent };